import React from 'react';
import { menuGroups } from '@/app/registry/menu';

interface SubMenuItem {
  name: string;
  href: string;
  permission: string | string[];
  subItems?: SubMenuItem[];
}

interface MenuItem {
  name: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
  permission: string | string[];
  subItems?: SubMenuItem[];
}

/**
 * Encontra a primeira página acessível baseada nas permissões do usuário
 * @param hasPermission Função que verifica se o usuário tem uma permissão específica
 * @returns URL da primeira página acessível ou null se não houver nenhuma
 */
export const getFirstAccessiblePage = (
  hasPermission: (permission: string) => boolean
): string | null => {
  const canAccess = (permission: string | string[]) =>
    Array.isArray(permission) ? permission.some((p) => hasPermission(p)) : hasPermission(permission);

  // O Dashboard (Sistema de Gestão) não entra: consulta tabelas que não existem no banco de Tributos.
  // Função recursiva para encontrar a primeira URL acessível em subitens
  const findFirstAccessibleSubItem = (subItems: SubMenuItem[]): string | null => {
    for (const subItem of subItems) {
      if (subItem.href !== '#' && canAccess(subItem.permission)) {
        return subItem.href;
      }
      if (subItem.subItems) {
        const found = findFirstAccessibleSubItem(subItem.subItems);
        if (found) return found;
      }
    }
    return null;
  };

  // Percorrer todos os grupos do menu
  for (const group of menuGroups) {
    for (const item of group.items) {
      // Verificar se o item principal tem uma URL válida e permissão
      if (item.href !== '#' && canAccess(item.permission)) {
        return item.href;
      }
      
      // Verificar subitens
      if (item.subItems) {
        const found = findFirstAccessibleSubItem(item.subItems);
        if (found) return found;
      }
    }
  }

  // Se não encontrou nenhuma página acessível, retorna null
  return null;
};
